import React from 'react';

import { css } from '@emotion/core';
import { Box } from '@rebass/emotion';
import Colors from '@theme/colors';

import { mq } from '@helpers/breakpoints';
interface ProgressBarProps {
  step: number;
}

const ProgressBar = ({ step }: ProgressBarProps) => {
  let width = '0%';

  if (step === 1 || step === 2) {
    width = '40%';
  }

  if (step === 3) {
    width = '60%';
  }

  if (step === 4) {
    width = '80%';
  }

  if (step === 5) {
    width = '100%';
  }

  return (
    <Box
      bg={Colors.grayDark9}
      css={mq({
        width: ['40%', '30%'],
        height: ['5px'],
        margin: ['auto'],
        overflow: ['visible'],
      })}
    >
      <Box
        css={css`
          background-color: ${Colors.darkOrange};
          background-position-y: 50%;
          height: 100%;
          width: ${width};
          ::after {
            border: solid ${Colors.darkOrange};
            border-radius: 3px;
            border-width: 0 3px 3px 0;
            bottom: 3px;
            content: '';
            display: block;
            float: right;
            height: 8px;
            position: relative;
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
            width: 8px;
          }
        `}
      />
    </Box>
  );
};

export default ProgressBar;
